module.exports = __webpack_public_path__ + "static/media/1.22f5d126.jpg";